module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"分公司":"Branch","河南富凯防护制品有限公司":"Henan Fukai Protective Products .","成立于2018年5月":"Established in May 2018","位于河南驻马店":"Located in Zhumadian, Henan","以生产一次性防护用品为主":"Mainly produces disposable protective equipment"},"zh":{"分公司":"分(子)公司","河南富凯防护制品有限公司":"河南富凯防护制品有限公司","成立于2018年5月":"成立于2018年5月","位于河南驻马店":"位于河南驻马店","以生产一次性防护用品为主":"以生产一次性防护用品为主"}}')
  delete Component.options._Ctor
}
